import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import outputs from '../../../../amplify_outputs.json';
import type { Schema } from '../../../../amplify/data/resource';

// Configure Amplify at module-evaluation time. ES module imports are evaluated
// top-to-bottom, so by importing this file (transitively or directly) any
// caller is guaranteed to see Amplify configured before they touch `client`.
// Avoids the previous race where `generateClient()` ran at import time but
// `Amplify.configure()` was called later from `main.tsx`, surfacing as
// "Amplify has not been configured" warnings on every page load.
Amplify.configure(outputs);

/**
 * Shared, fully-typed Amplify GraphQL client.
 * Using the `Schema` generic means `client.queries.*`, `client.mutations.*`,
 * and `client.subscriptions.*` are all strongly typed against the Amplify
 * schema defined in `amplify/data/resource.ts`. No `as unknown as ...` casts.
 */
export const client = generateClient<Schema>();

// Re-exported for callers that have not yet migrated to the shared `client`.
export { generateClient } from 'aws-amplify/api';
